export default __webpack_public_path__ + "static/media/coming-soon.70f673b9.png";